import styles from "./BlockedName.module.scss";

/** Отключение доступа, как его отдаёт сущность пользователя */
export interface UserAccessBlock {
  /** Дата и время строкой; at - то же без времени (DateTime в JSON) */
  atText?: string;
  at?: string;
  by: { id: string; name: string } | null;
  reason: string | null;
}

/** «Отключён 13.10.2026 14:05, Селезнёв К. — причина» */
export const blockedTitle = (at: string, by?: string | null, reason?: string | null) =>
  `Доступ отключён ${at}${by ? `, ${by}` : ""}${reason ? ` — ${reason}` : ""}`;

/**
 * Имя в списках сотрудников и контрагентов: доступ к приложению отключён - красным,
 * кто, когда и почему - подсказкой. Ячейка AG Grid
 */
export const BlockedName = ({ value, data }: { value?: string; data?: { accessBlocked?: UserAccessBlock | null } }) => {
  const blocked = data?.accessBlocked;

  return blocked ? (
    <span className={styles.blocked} title={blockedTitle(blocked.atText ?? blocked.at ?? "", blocked.by?.name, blocked.reason)}>
      {value}
    </span>
  ) : (
    <>{value}</>
  );
};
